// src/pages/maintenance/components/MaintenanceContractList/useProposalsFormLogic.js

import { useState, useEffect } from 'react';
import API_BASE_URL from '../../../../Constants';

export const downloadProposalPdf = async (proposalNumber, setIsLoading = null) => {
    if (!proposalNumber) {
        alert('Proposal number is required to download the PDF');
        return;
    }

    try {
        if (setIsLoading) {
            setIsLoading(true);
        }

        const response = await fetch(`${API_BASE_URL}/api/proposals-and-jobs/proposals/${proposalNumber}/pdf`);
        if (!response.ok) {
            throw new Error('Failed to download the PDF');
        }

        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);

        const a = document.createElement('a');
        a.href = url;
        a.download = `proposal_${proposalNumber}.pdf`;
        a.click();
        window.URL.revokeObjectURL(url);

        alert('PDF downloaded successfully');
    } catch (error) {
        console.error('Error downloading the PDF:', error);
        alert('Failed to download the PDF. Please try again.');
    } finally {
        if (setIsLoading) {
            setIsLoading(false);
        }
    }
};


const useProposalsFormLogic = (open, proposal = null) => {
    const [formData, setFormData] = useState(proposal || {});
    const [options, setOptions] = useState({});

    const getProposalClassesFromSubClasses = (subClasses) => {
        const uniqueClasses = new Map();

        subClasses.forEach(subClass => {
            const { classId, className } = subClass.proposalClass;
            if (!uniqueClasses.has(classId)) {
                uniqueClasses.set(classId, { classId, className });
            }
        });

        return Array.from(uniqueClasses.values());
    }


    useEffect(() => {
        if (proposal) {
            setFormData(proposal);
        }
    }
        , [proposal]);


    useEffect(() => {
        const fetchOptions = async () => {
            try {
                const [
                    buildingsRes,
                    salesRepRes,
                    proposalSubClassRes

                ] = await Promise.all([
                    fetch(API_BASE_URL + '/api/setup/buildings/all', { credentials: 'include' }).then(res => res.json()),
                    fetch(API_BASE_URL + '/api/setup/salesperson/salespersons', { credentials: 'include' }).then(res => res.json()),
                    fetch(API_BASE_URL + '/api/proposals-and-jobs/subclasses', { credentials: 'include' }).then(res => res.json()),

                ]);

                setOptions({
                    building: buildingsRes || [],
                    salesPerson: salesRepRes || [],
                    proposalSubClass: proposalSubClassRes || [],
                    proposalClass: getProposalClassesFromSubClasses(proposalSubClassRes) || [],
                });
            } catch (error) {
                console.error('Error fetching dropdown options:', error);
            }
        };



        if (open) {
            fetchOptions();
        }
    }, [open]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({ ...prevData, [name]: value }));
    };

    return {
        formData,
        setFormData,
        options,
        handleInputChange,
    };
};


export default useProposalsFormLogic;
